import ScrollableAnchor, { configureAnchors } from 'react-scrollable-anchor';
import Hero from '../Hero';
import WhatItDoes from '../WhatItDoes';
import HowItWorks from '../HowItWorks';
import OurBusiness from '../OurBusiness';
import OurTeam from '../OurTeam';
import ContactUs from '../ContactUs';
import LookingForTheFuture from '../LookingForTheFuture';
import Feeds from '../Feeds';
import OurOffices from '../OurOffices';

// Offset all anchors to account for a fixed header
configureAnchors({ offset: -105 });

const App = () => (
	<main>
		<link
			href="https://assets.calendly.com/assets/external/widget.css"
			rel="stylesheet"
		/>
		<script
			async
			src="https://assets.calendly.com/assets/external/widget.js"
			type="text/javascript"
		/>

		<script
			src="//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js"
			type="text/javascript"
		/>
		<script
			async
			src="https://www.googletagmanager.com/gtag/js?id=UA-123683947-2"
		/>

		{/* eslint-disable-next-line */}
		<script dangerouslySetInnerHTML={{ __html: `window.dataLayer = window.dataLayer || []; function gtag() { window.dataLayer.push(arguments); } gtag('js', new Date()); gtag('config', 'UA-123683947-2');` }} />

		<ScrollableAnchor id={'home'}>
			<Hero />
		</ScrollableAnchor>
		<ScrollableAnchor id={'what'}>
			<WhatItDoes />
		</ScrollableAnchor>
		<Feeds />

		<ScrollableAnchor id={'how'}>
			<HowItWorks />
		</ScrollableAnchor>

		<ScrollableAnchor id={'business'}>
			<OurBusiness />
		</ScrollableAnchor>
		<LookingForTheFuture />
		<ScrollableAnchor id={'our-team'}>
			<OurTeam />
		</ScrollableAnchor>
		<OurOffices />
		<ScrollableAnchor id={'contact-us'}>
			<ContactUs />
		</ScrollableAnchor>
	</main>
);

export default App;



// WEBPACK FOOTER //
// ./components/App/index.jsx